import { ResourceOverviewPanel } from '@/components/dashboard/ResourceOverviewPanel';
import { BudgetDashboard } from '@/components/dashboard/BudgetDashboard';
import { DataModeToggle } from '@/components/DataModeToggle';
import { useScreenData } from '@/hooks/useScreenData';

export function DashboardOverview() {
  const { resources, bookings, projects } = useScreenData('overview');

  return (
    <div className="h-full overflow-y-auto overflow-x-hidden">
    <div className="w-full p-6 space-y-6">
      <div className="flex items-start justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Dashboard Overview</h1>
          <p className="text-muted-foreground mt-2">
            Comprehensive view of resource allocation, budget tracking, and team availability
          </p>
        </div>
        <div className="flex items-center gap-3">
          <DataModeToggle screen="overview" />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Resource Overview Panel */}
        <ResourceOverviewPanel resources={resources} />
      </div>

      {/* Budget Dashboard - Full Width */}
      <BudgetDashboard projects={projects} />
    </div>
    </div>
  );
}
